// @flow

export function convertObjectIntoQueryString(obj: Object): string {
  return Object.keys(obj).map((key: string) => {
    const encodedKey = encodeURIComponent(key);
    const encodedValue = encodeURIComponent(obj[key]);
    return `${encodedKey}=${encodedValue}`;
  }).join('&');
}
